// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"1854413b","480":"9dbcd808","838":"65b76d2f"}[chunkId] + ".js";
};